import './All.css'
import { Nav } from './Nav';
import { NavLeft } from './NavLeft';
import { NavRight } from './NavRight';
import { SectionA2 } from './sectionA2';
import { SectionB } from './SectionB';
import { SectionC } from './SectionC';
import { SectionD } from './SectionD';
import { SectionE } from './SectionE';
import { SectionF } from './SectionF';


function App() {
  // const handleRef = (param) => window.scrollTo(0, param);
  return (
    <div>
      <Nav />
      <div className="main">
        <SectionA2 />
        <SectionB />
        <SectionC />
        <SectionD />
        <SectionE />
        <SectionF />
      </div>
      <NavLeft />
      <NavRight />
    </div>
  );
}

export default App;